import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'es' : 'en');
    
    // Update URL with language parameter for SEO and sharing
    const newLanguage = language === 'en' ? 'es' : 'en';
    const url = new URL(window.location.href);
    url.searchParams.set('lang', newLanguage);
    window.history.replaceState({}, '', url);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="bg-gray-800 hover:bg-gray-700 text-white px-2 py-1 rounded text-xs flex items-center gap-0.5 transition-colors border border-gray-700"
      aria-label={language === 'en' ? 'Switch to Spanish' : 'Switch to English'}
    >
      <Globe className="h-3 w-3 text-gray-400 mr-0.5" />
      <span className={language === 'en' ? 'font-medium' : 'text-gray-400'}>EN</span>
      <span className="mx-0.5 text-gray-500">|</span>
      <span className={language === 'es' ? 'font-medium' : 'text-gray-400'}>ES</span>
    </button>
  );
};

export default LanguageToggle;